import React from "react";

import "./index.scss";

const DownloadIcon = () => (
  <div>
    <svg id="Cross" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="icon-download">
      <rect id="Margin" className="icon-download__container" width="32" height="32" />
      <g id="Group_10807" data-name="Group 10807">
        <path id="Path_9123" data-name="Path 9123" d="M11.707,15l.7-.7L15.5,17.374V8.5h1v8.874L19.589,14.3l.7.7L16,19.293Z" className="icon__path" />
        <rect id="Rectangle_664" data-name="Rectangle 664" width="16" height="1" transform="translate(8 23)" className="icon__path" />
      </g>
    </svg>
  </div>
);

export default DownloadIcon;
